export const BANNER_CONFIG = {
  cardPayment: { key: 'cardPayment', label: 'Kartično plaćanje' },
  intervend: { key: 'intervend', label: 'Intervend' },
  mywash: { key: 'mywash', label: 'MyWash' },
};
